import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Layout, Menu,Button,Modal } from "antd";
import { reactLocalStorage } from "reactjs-localstorage";
import { httpPost, httpUrl } from "../api/httpClient";
import con from "../const";
import { connect } from "react-redux";
import { AppstoreOutlined, FileOutlined, SettingOutlined,UserOutlined, TeamOutlined, WalletOutlined } from '@ant-design/icons';

const SubMenu = Menu.SubMenu;

class Sider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openKeys: [],
      menus: [],
      selectedMenu: [],
    };
  }

  componentDidMount() {
}


handleChangeTabStatus = (key) => {
    const userInfo = reactLocalStorage.getObject(con.appName + "#adminUser");
    let selectedMenu = [];
    if (key) {
      this.setState({
          selectedMenu: [key],
        });
    } else {
      userInfo.adminAuth.forEach((value, index) => {
          if (value.subMenu) {
          value.subMenu.forEach((c) => {
              if (c.path === this.props.location.pathname) {
                  selectedMenu = [c.name];
                }
            });
        } else {
            if (value.path === this.props.location.pathname) {
                selectedMenu = [value.name];
            }
        }
    });
    this.setState({
        selectedMenu: selectedMenu,
    });
}
};
logout = () => {
    Modal.confirm({
      title: "로그아웃",
      content: "로그아웃 하시겠습니까?",
      okText: "확인",
      cancelText: "취소",
      onOk() {
        httpPost(httpUrl.logout, [], {})
          .then(() => {
            global.location.href = "/";
          })
          .catch((e) => {
            global.location.href = "/";
          });
      }
    })
  };

render() {
    return (
      <Layout.Sider
        style={{height: '100vh', 
        backgroundColor:"#0b3246"
    }}
        breakpoint="lg"
        collapsedWidth="0"
        onCollapse={(collapsed, type) => { }}>
        <div
          style={{
            textAlign: "center",
            backgroundColor: "#75b1cc",
            padding: "20px 10px",
            color:'#24698b',
            fontWeight: 500,
            display:'flex',
            justifyContent:'space-between'
          }}
        >
          {/* <Link exact="true" to='/Main' style={{color: "#222", fontWeight: "bold"}}> */}

            <div style={{color:'#24698b'}}>
                <span style={{marginRight:10}}><UserOutlined /></span>
                관리자
            </div>
            <div
                style={{borderBottom:'1px solid #24698b',fontSize:14,cursor:'pointer' }}
                onClick={this.logout}
              >
                Logout 
              </div>
          {/* </Link> */}
        </div>
        <Menu
          theme="dark"
          selectedKeys={this.state.selectedMenu}
          mode="inline"
          inlineIndent={15}
          onClick={(item) => {
            this.handleChangeTabStatus(item.key);
        }}>
        {/* <SubMenu
            key='statistics'
            title={
              <span>
                <span>STATISTICS</span>
              </span>
          }>
            <Menu.Item
              key='UserList'
            >
              <Link to='/statistics/UserList'>
                <span className="nav-text">
                  누적 통계
                </span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key='UserList'
            >
              <Link to='/statistics/UserList'>
                <span className="nav-text">
                  기간별 통계
                </span>
              </Link>
            </Menu.Item>
        </SubMenu> */}
        <SubMenu
            style={{cursor: "pointer"}}
            key='transaction'
            title={
              <span style={{paddingLeft:10}}>
             <AppstoreOutlined />
                <span style={{marginLeft:10}}>TRANSACTION</span>
              </span>
          }>
            <Menu.Item
              key='DepositRequestList'
            >
              <Link to='/transaction/DepositRequestList'>
                <span className="nav-text">
                  입금 신청 내역
                </span>
              </Link>
            </Menu.Item>
            {/* <Menu.Item
              key='TransferRequestList'
            >
              <Link to='/transaction/TransferRequestList'>
                <span className="nav-text">
                 출금 신청 내역
                </span>
              </Link>
            </Menu.Item> */}
            <Menu.Item
              key='DepositList'
            >
              <Link to='/transaction/DepositList'>
                <span className="nav-text">
                 입금 내역
                </span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key='WithdrawList'
            >
              <Link to='/transaction/WithdrawList'>
                <span className="nav-text">
                 출금 내역
                </span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key='ParentTransactionList'
            >
              <Link to='/transaction/ParentTransactionList'>
                <span className="nav-text">
                 집금계좌
                </span>
              </Link>
            </Menu.Item>
        </SubMenu>
        <SubMenu
            style={{cursor: "pointer"}}
            key='wallet'
            title={
              <span style={{paddingLeft:10}}>
             <WalletOutlined />
                <span style={{marginLeft:10}}>WALLET</span>
              </span>
          }>
            <Menu.Item
              key='MergeList'
            >
              <Link to='/wallet/MergeList'>
                <span className="nav-text">
                  지갑 모으기
                </span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key='MergeLogList'
            >
              <Link to='/wallet/MergeLogList'>
                <span className="nav-text">
                 모으기 내역
                </span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key='EthLogList'
            >
              <Link to='/wallet/EthLogList'>
                <span className="nav-text">
                 수수료 지급 내역
                </span>
              </Link>
            </Menu.Item>
        </SubMenu>
        <SubMenu
            style={{cursor: "pointer"}}
            key='settings'
            title={
                <span style={{paddingLeft:10}}>
                <SettingOutlined/>
                <span style={{marginLeft:10}}>SETTINGS</span>
              </span>
          }>
            <Menu.Item
              key='AssetWithdraw'
            >
              <Link to='/setting/AssetWithdraw'>
                <span className="nav-text">
                  자산인출
                </span>
              </Link>
            </Menu.Item>
        </SubMenu>
        <SubMenu
            style={{cursor: "pointer"}}
            key='admin'
            title={
                <span style={{paddingLeft:10}}>
                <FileOutlined />
                <span style={{marginLeft:10}}>ADMIN</span>
              </span>
          }>
            <Menu.Item
              key='AdminInfo'
            >
              <Link to='/admin/AdminInfo'>
                <span className="nav-text">
                관리자정보
                </span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key='CompanyInfo'
            >
              <Link to='/admin/CompanyInfo'>
                <span className="nav-text">
                업체정보
                </span>
              </Link>
            </Menu.Item>
        </SubMenu>
        <SubMenu
            style={{cursor: "pointer"}}
            key='user'
            title={
                <span style={{paddingLeft:10}}>
               <TeamOutlined />
                <span style={{marginLeft:10}}>USER</span>
              </span>
          }>
            <Menu.Item
              key='userList'
            >
              <Link to='/user/UserList'>
                <span className="nav-text">
                유저 목록
                </span>
              </Link>
            </Menu.Item>          
        </SubMenu>
        <SubMenu
            style={{cursor: "pointer"}}
            key='log'
            title={
                <span style={{paddingLeft:10}}>
                <FileOutlined />
                <span style={{marginLeft:10}}>LOG</span>
              </span>
          }>
            <Menu.Item
              key='Loginlog'
            >
              <Link to='/log/AdminLoginLog'>
                <span className="nav-text">
                로그인 로그
                </span>
              </Link>
            </Menu.Item>          
        </SubMenu>
        </Menu>
      </Layout.Sider>
    );
  }
}



export default Sider;
